import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c1aafc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headerFormulario" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestaoOpcoes = _resolveComponent("QuestaoOpcoes")!
  const _component_QuestaoSelecoes = _resolveComponent("QuestaoSelecoes")!
  const _component_BotaoGerarRelatorio = _resolveComponent("BotaoGerarRelatorio")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.esteFormulario.getTitulo()), 1),
      (_ctx.esteFormulario.getSubtitulo())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.esteFormulario.getSubtitulo()), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_TransitionGroup, { tag: "QuestaoOpcoes" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.esteFormulario.getQuestoes(), (questao) => {
          return (_openBlock(), _createElementBlock("div", {
            key: questao.getId()
          }, [
            (questao.getTipo() === 'opcao')
              ? (_openBlock(), _createBlock(_component_QuestaoOpcoes, {
                  key: 0,
                  questao: questao as QuestaoDeOpcoes
                }, null, 8, ["questao"]))
              : (questao.getTipo() === 'selecao')
                ? (_openBlock(), _createBlock(_component_QuestaoSelecoes, {
                    key: 1,
                    questao: questao as QuestaoDeSelecao
                  }, null, 8, ["questao"]))
                : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_BotaoGerarRelatorio, {
      formulario: _ctx.formulario,
      processadorFormulario: _ctx.processadorFormulario,
      onGerouRelatorio: _ctx.gerouRelatorio
    }, null, 8, ["formulario", "processadorFormulario", "onGerouRelatorio"])
  ]))
}